import { ProfileMenu } from "./ProfileMenu";

export const Header = () => (
  <header className="border-b border-gray-200 bg-white">
    <div className="flex items-center justify-between px-6 py-3">
      <div className="flex items-center">
        <img
          src="/assets/tokio-marine-logo.png"
          alt="Tokio Marine HCC"
          className="h-10 w-auto"
        />
      </div>

      <ProfileMenu />
    </div>
  </header>
);
